// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.steps-navigation {
  width: 100%;
}
.steps-navigation__sections {
  position: relative;
  height: 32px;
  overflow: hidden;
  width: 100%;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.steps-navigation__sections li {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--sebrae-light-gray5);
  background: var(--sebrae-white-4);
  padding: 5px 16px;
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.steps-navigation__sections li.steps-navigation__name {
  width: 100%;
  height: 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--sebrae-purple);
  color: var(--sebrae-white);
  padding: 5px 16px;
  font-size: 13px;
  font-weight: 700;
  border: none;
  cursor: pointer;
}
.steps-navigation__sections li.steps-navigation__name .steps-navigation__sections__text {
  font: inherit;
  color: inherit;
}
.steps-navigation__sections li.steps-navigation__name .steps-navigation__sections__icon {
  display: none;
}
.steps-navigation__sections li.steps-navigation__name.incomplete, .steps-navigation__sections li.steps-navigation__name.completed {
  background: var(--sebrae-purple);
  color: var(--sebrae-white);
}
.steps-navigation__sections li.steps-navigation__name.incomplete .steps-navigation__sections__text, .steps-navigation__sections li.steps-navigation__name.completed .steps-navigation__sections__text {
  color: var(--sebrae-white);
}
.steps-navigation__sections li.steps-navigation__name img {
  pointer-events: inherit;
  transform: scaleY(-1);
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.steps-navigation__sections li.steps-navigation__name img.open {
  transform: scaleY(1);
}
.steps-navigation__sections li.incomplete {
  border-color: var(--sebrae-white);
  background: var(--sebrae-yellow2);
}
.steps-navigation__sections li.incomplete .steps-navigation__sections__text {
  color: var(--sebrae-gray);
}
.steps-navigation__sections li.completed {
  border-color: var(--sebrae-white);
  background: var(--sebrae-blue-6);
}
.steps-navigation__sections li.completed .steps-navigation__sections__text {
  color: var(--sebrae-white);
}
.steps-navigation__sections li.current {
  height: 56px;
}
.steps-navigation__sections li.incomplete, .steps-navigation__sections li.completed, .steps-navigation__sections li.current {
  cursor: pointer;
}
.steps-navigation__sections__text {
  font-size: 19px;
  font-weight: 700;
  color: var(--sebrae-blue-6);
  transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
  text-align: left;
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}
.steps-navigation__sections__text span {
  font-size: 13px;
  font-weight: 400;
}
.steps-navigation__sections__text.desktop {
  display: none;
}
.steps-navigation__sections.open {
  height: 480px;
}
.steps-navigation__sections.open li.steps-navigation__name {
  height: 32px;
}
.steps-navigation__sections:not(.open) {
  height: 88px;
}
.steps-navigation__sections:not(.open).first-step {
  height: 56px;
}
.steps-navigation__sections:not(.open) li.current {
  position: absolute;
  top: 32px;
  left: 0;
  z-index: 1;
}
.steps-navigation__sections:not(.open) li.current.steps-navigation__name {
  top: 0;
}
@media screen and (min-width: 768px) {
  .steps-navigation {
    max-width: 295px;
    min-width: 216px;
  }
  .steps-navigation__name {
    cursor: inherit;
    height: auto;
  }
  .steps-navigation__name img {
    display: none;
  }
  .steps-navigation__sections {
    height: auto !important;
  }
  .steps-navigation__sections li {
    position: relative !important;
    top: 0 !important;
    background: transparent !important;
    min-height: 17px;
    height: auto !important;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0 0 0 24px;
    border: none;
    margin-bottom: 24px;
  }
  .steps-navigation__sections li.steps-navigation__name {
    padding: 0 0 0 24px;
    font-size: 16px;
    font-weight: 400;
    color: var(--sebrae-purple);
    height: 17px;
  }
  .steps-navigation__sections li.steps-navigation__name .steps-navigation__sections__icon {
    display: flex;
    top: 3px;
  }
  .steps-navigation__sections li.steps-navigation__name.completed {
    color: var(--sebrae-purple);
  }
  .steps-navigation__sections li.steps-navigation__name.completed .steps-navigation__sections__text {
    color: var(--sebrae-purple);
  }
  .steps-navigation__sections li.steps-navigation__name.completed:before {
    border-color: var(--sebrae-purple);
    background: var(--sebrae-purple);
  }
  .steps-navigation__sections li.steps-navigation__name.incomplete .steps-navigation__sections__text {
    color: var(--sebrae-purple);
  }
  .steps-navigation__sections li.steps-navigation__name.incomplete:before {
    border-color: var(--sebrae-purple);
    background: var(--sebrae-purple);
  }
  .steps-navigation__sections li.steps-navigation__name.current {
    color: var(--sebrae-purple);
  }
  .steps-navigation__sections li.steps-navigation__name.current .steps-navigation__sections__text {
    color: var(--sebrae-purple);
  }
  .steps-navigation__sections li.steps-navigation__name.current:before {
    border-color: var(--sebrae-purple);
  }
  .steps-navigation__sections li.steps-navigation__name:before {
    border-color: var(--sebrae-purple);
  }
  .steps-navigation__sections li.incomplete {
    color: var(--sebrae-yellow2);
  }
  .steps-navigation__sections li.incomplete .steps-navigation__sections__text {
    color: var(--sebrae-yellow2);
  }
  .steps-navigation__sections li.incomplete:before {
    border-color: var(--sebrae-yellow2);
    background-color: var(--sebrae-yellow2);
  }
  .steps-navigation__sections li.completed, .steps-navigation__sections li.current {
    color: var(--sebrae-blue-6);
  }
  .steps-navigation__sections li.completed .steps-navigation__sections__text, .steps-navigation__sections li.current .steps-navigation__sections__text {
    color: var(--sebrae-blue-6);
  }
  .steps-navigation__sections li.completed:before, .steps-navigation__sections li.current:before {
    border-color: var(--sebrae-blue-6);
  }
  .steps-navigation__sections li.completed:before {
    background-color: var(--sebrae-blue-6);
  }
  .steps-navigation__sections li.current .steps-navigation__sections__text {
    font-weight: 700;
  }
  .steps-navigation__sections li:before {
    content: "";
    width: 16px;
    height: 16px;
    background: transparent;
    border-radius: 4px;
    border: 1px solid var(--sebrae-light-gray2);
    position: absolute;
    left: 0;
    transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  .steps-navigation__sections li:after {
    content: "";
    width: 1px;
    height: 16px;
    background: var(--sebrae-light-gray2);
    position: absolute;
    left: 8px;
    top: 21px;
    cursor: inherit;
    pointer-events: none;
  }
  .steps-navigation__sections li:last-of-type {
    margin-bottom: 0;
  }
  .steps-navigation__sections li:last-of-type:after {
    display: none;
  }
  .steps-navigation__sections__icon {
    position: absolute;
    top: 2px;
    left: 2px;
    color: var(--sebrae-white);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .steps-navigation__sections__icon svg {
    width: 12px;
    height: 12px;
  }
  .steps-navigation__sections__text {
    color: var(--sebrae-light-gray2);
    font-size: 16px;
    font-weight: 400;
    flex-direction: column;
    align-items: flex-start;
    gap: 1px;
  }
  .steps-navigation__sections__text.mobile {
    display: none;
  }
  .steps-navigation__sections__text.desktop {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/planning/components/steps/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACE;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,kDAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kDAAA;EACA,iCAAA;EACA,iBAAA;EACA,kDAAA;AACN;AACM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,0BAAA;EACA,iBAAA;EAEE,eAAA;EACA,gBAAA;EAEF,YAAA;EACA,eAAA;AADR;AAGQ;EACE,aAAA;EACA,cAAA;AADV;AAGQ;EACE,aAAA;AADV;AAIQ;EACE,gCAAA;EACA,0BAAA;AAFV;AAIU;EACE,0BAAA;AAFZ;AAKQ;EACE,uBAAA;EACA,qBAAA;EACA,kDAAA;AAHV;AAKU;EACE,oBAAA;AAHZ;AAOM;EACE,iCAAA;EACA,iCAAA;AALR;AAOQ;EACE,yBAAA;AALV;AAQM;EACE,iCAAA;EACA,gCAAA;AANR;AAQQ;EACE,0BAAA;AANV;AASM;EACE,YAAA;AAPR;AAUM;EACE,eAAA;AARR;AAWI;EAEI,eAAA;EACA,gBAAA;EAEF,2BAAA;EACA,kDAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAXN;AAaM;EAEI,eAAA;EACA,gBAAA;AAZV;AAgBM;EACE,aAAA;AAdR;AAkBI;EACE,aAAA;AAhBN;AAkBM;EACE,YAAA;AAhBR;AAmBI;EACE,YAAA;AAjBN;AAmBM;EACE,YAAA;AAjBR;AAmBM;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;AAjBR;AAmBQ;EACE,MAAA;AAjBV;AAuBE;EA1IF;IA2II,gBAAA;IACA,gBAAA;EApBF;EAsBE;IACE,eAAA;IACA,YAAA;EApBJ;EAsBI;IACE,aAAA;EApBN;EAuBE;IACE,uBAAA;EArBJ;EAuBI;IACE,6BAAA;IACA,iBAAA;IACA,kCAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,2BAAA;IACA,mBAAA;IACA,YAAA;IACA,mBAAA;EArBN;EAuBM;IACE,mBAAA;IAEE,eAAA;IACA,gBAAA;IAEF,2BAAA;IACA,YAAA;EAvBR;EAyBQ;IACE,aAAA;IACA,QAAA;EAvBV;EAyBQ;IACE,2BAAA;EAvBV;EAyBU;IACE,2BAAA;EAvBZ;EAyBU;IACE,kCAAA;IACA,gCAAA;EAvBZ;EA2BU;IACE,2BAAA;EAzBZ;EA2BU;IACE,kCAAA;IACA,gCAAA;EAzBZ;EA4BQ;IACE,2BAAA;EA1BV;EA4BU;IACE,2BAAA;EA1BZ;EA4BU;IACE,kCAAA;EA1BZ;EA6BQ;IACE,kCAAA;EA3BV;EA8BM;IACE,4BAAA;EA5BR;EA8BQ;IACE,4BAAA;EA5BV;EA+BQ;IACE,mCAAA;IACA,uCAAA;EA7BV;EAgCM;IACE,2BAAA;EA9BR;EAgCQ;IACE,2BAAA;EA9BV;EAgCQ;IACE,kCAAA;EA9BV;EAkCQ;IACE,sCAAA;EAhCV;EAoCQ;IACE,gBAAA;EAlCV;EAsCM;IACE,WAAA;IACA,WAAA;IACA,YAAA;IACA,uBAAA;IACA,kBAAA;IACA,2CAAA;IACA,kBAAA;IACA,OAAA;IACA,kDAAA;EApCR;EAsCM;IACE,WAAA;IACA,UAAA;IACA,YAAA;IACA,qCAAA;IACA,kBAAA;IACA,SAAA;IACA,SAAA;IACA,eAAA;IACA,oBAAA;EApCR;EA2CM;IACE,gBAAA;EAzCR;EA2CQ;IACE,aAAA;EAzCV;EA6CI;IACE,kBAAA;IACA,QAAA;IACA,SAAA;IACA,0BAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EA3CN;EA6CM;IACE,WAAA;IACA,YAAA;EA3CR;EA8CI;IACE,gCAAA;IAEE,eAAA;IACA,gBAAA;IAEF,sBAAA;IACA,uBAAA;IACA,QAAA;EA9CN;EAgDM;IACE,aAAA;EA9CR;EAgDM;IACE,aAAA;EA9CR;AACF","sourcesContent":[".steps-navigation {\n  width: 100%;\n\n  &__sections {\n    position: relative;\n    height: 32px;\n    overflow: hidden;\n    width: 100%;\n    transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n    li {\n      width: 100%;\n      height: 56px;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      border-bottom: 1px solid var(--sebrae-light-gray5);\n      background: var(--sebrae-white-4);\n      padding: 5px 16px;\n      transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n      &.steps-navigation__name {\n        width: 100%;\n        height: 32px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        background: var(--sebrae-purple);\n        color: var(--sebrae-white);\n        padding: 5px 16px;\n        font: {\n          size: 13px;\n          weight: 700;\n        }\n        border: none;\n        cursor: pointer;\n\n        .steps-navigation__sections__text {\n          font: inherit;\n          color: inherit;\n        }\n        .steps-navigation__sections__icon {\n          display: none;\n        }\n\n        &.incomplete, &.completed {\n          background: var(--sebrae-purple);\n          color: var(--sebrae-white);\n\n          .steps-navigation__sections__text {\n            color: var(--sebrae-white);\n          }\n        }\n        img {\n          pointer-events: inherit;\n          transform: scaleY(-1);\n          transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n          &.open {\n            transform: scaleY(1);\n          }\n        }\n      }\n      &.incomplete {\n        border-color: var(--sebrae-white);\n        background: var(--sebrae-yellow2);\n\n        .steps-navigation__sections__text {\n          color: var(--sebrae-gray);\n        }\n      }\n      &.completed {\n        border-color: var(--sebrae-white);\n        background: var(--sebrae-blue-6);\n\n        .steps-navigation__sections__text {\n          color: var(--sebrae-white);\n        }\n      }\n      &.current {\n        height: 56px;\n      }\n\n      &.incomplete, &.completed, &.current {\n        cursor: pointer;\n      }\n    }\n    &__text {\n      font: {\n        size: 19px;\n        weight: 700;\n      }\n      color: var(--sebrae-blue-6);\n      transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n      text-align: left;\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      flex-wrap: wrap;\n\n      span {\n        font: {\n          size: 13px;\n          weight: 400;\n        }\n      }\n\n      &.desktop {\n        display: none;\n      }\n    }\n\n    &.open {\n      height: calc(448px + 32px);\n\n      li.steps-navigation__name {\n        height: 32px;\n      }\n    }\n    &:not(.open) {\n      height: 88px;\n\n      &.first-step {\n        height: 56px;\n      }\n      li.current {\n        position: absolute;\n        top: 32px;\n        left: 0;\n        z-index: 1;\n\n        &.steps-navigation__name {\n          top: 0;\n        }\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    max-width: 295px;\n    min-width: 216px;\n\n    &__name {\n      cursor: inherit;\n      height: auto;\n\n      img {\n        display: none;\n      }\n    }\n    &__sections {\n      height: auto!important;\n\n      li {\n        position: relative!important;\n        top: 0!important;\n        background: transparent!important;\n        min-height: 17px;\n        height: auto!important;\n        align-items: flex-start;\n        justify-content: flex-start;\n        padding: 0 0 0 24px;\n        border: none;\n        margin-bottom: 24px;\n\n        &.steps-navigation__name {\n          padding: 0 0 0 24px;\n          font: {\n            size: 16px;\n            weight: 400;\n          }\n          color: var(--sebrae-purple);\n          height: 17px;\n\n          .steps-navigation__sections__icon {\n            display: flex;\n            top: 3px;\n          }\n          &.completed {\n            color: var(--sebrae-purple);\n\n            .steps-navigation__sections__text {\n              color: var(--sebrae-purple);\n            }\n            &:before {\n              border-color: var(--sebrae-purple);\n              background: var(--sebrae-purple);\n            }\n          }\n          &.incomplete {\n            .steps-navigation__sections__text {\n              color: var(--sebrae-purple);\n            }\n            &:before {\n              border-color: var(--sebrae-purple);\n              background: var(--sebrae-purple);\n            }\n          }\n          &.current {\n            color: var(--sebrae-purple);\n\n            .steps-navigation__sections__text {\n              color: var(--sebrae-purple);\n            }\n            &:before {\n              border-color: var(--sebrae-purple);\n            }\n          }\n          &:before {\n            border-color: var(--sebrae-purple);\n          }\n        }\n        &.incomplete {\n          color: var(--sebrae-yellow2);\n\n          .steps-navigation__sections__text {\n            color: var(--sebrae-yellow2);\n          }\n\n          &:before {\n            border-color: var(--sebrae-yellow2);\n            background-color: var(--sebrae-yellow2);\n          }\n        }\n        &.completed, &.current {\n          color: var(--sebrae-blue-6);\n\n          .steps-navigation__sections__text {\n            color: var(--sebrae-blue-6);\n          }\n          &:before {\n            border-color: var(--sebrae-blue-6);\n          }\n        }\n        &.completed {\n          &:before {\n            background-color: var(--sebrae-blue-6);\n          }\n        }\n        &.current {\n          .steps-navigation__sections__text {\n            font-weight: 700;\n          }\n        }\n\n        &:before {\n          content: '';\n          width: 16px;\n          height: 16px;\n          background: transparent;\n          border-radius: 4px;\n          border: 1px solid var(--sebrae-light-gray2);\n          position: absolute;\n          left: 0;\n          transition: all 255ms cubic-bezier(0.4, 0, 0.2, 1);\n        }\n        &:after {\n          content: '';\n          width: 1px;\n          height: 16px;\n          background: var(--sebrae-light-gray2);\n          position: absolute;\n          left: 8px;\n          top: 21px;\n          cursor: inherit;\n          pointer-events:  none;\n        }\n        //&:nth-child(8) {\n        //  &:after {\n        //    height: 30px;\n        //  }\n        //}\n        &:last-of-type {\n          margin-bottom: 0;\n\n          &:after {\n            display: none;\n          }\n        }\n      }\n      &__icon {\n        position: absolute;\n        top: 2px;\n        left: 2px;\n        color:  var(--sebrae-white);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        svg {\n          width: 12px;\n          height: 12px;\n        }\n      }\n      &__text {\n        color: var(--sebrae-light-gray2);\n        font: {\n          size: 16px;\n          weight: 400;\n        }\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 1px;\n\n        &.mobile {\n          display: none;\n        }\n        &.desktop {\n          display: flex;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
